import ProfitReport from './profit.reports/Profit.reports'

export default {
  ProfitReport
}
